/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginWithEmailAndPasswordSuccessResponse
 */
export interface LoginWithEmailAndPasswordSuccessResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordSuccessResponse
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordSuccessResponse
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordSuccessResponse
     */
    idToken: string;
    /**
     * 
     * @type {number}
     * @memberof LoginWithEmailAndPasswordSuccessResponse
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordSuccessResponse
     */
    tokenType: string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordSuccessResponse
     */
    authFlow: LoginWithEmailAndPasswordSuccessResponseAuthFlowEnum;
}


/**
 * @export
 */
export const LoginWithEmailAndPasswordSuccessResponseAuthFlowEnum = {
    Login: 'LOGIN'
} as const;
export type LoginWithEmailAndPasswordSuccessResponseAuthFlowEnum = typeof LoginWithEmailAndPasswordSuccessResponseAuthFlowEnum[keyof typeof LoginWithEmailAndPasswordSuccessResponseAuthFlowEnum];


/**
 * Check if a given object implements the LoginWithEmailAndPasswordSuccessResponse interface.
 */
export function instanceOfLoginWithEmailAndPasswordSuccessResponse(value: object): value is LoginWithEmailAndPasswordSuccessResponse {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    if (!('authFlow' in value) || value['authFlow'] === undefined) return false;
    return true;
}

export function LoginWithEmailAndPasswordSuccessResponseFromJSON(json: any): LoginWithEmailAndPasswordSuccessResponse {
    return LoginWithEmailAndPasswordSuccessResponseFromJSONTyped(json, false);
}

export function LoginWithEmailAndPasswordSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginWithEmailAndPasswordSuccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
        'idToken': json['idToken'],
        'expiresIn': json['expiresIn'],
        'tokenType': json['tokenType'],
        'authFlow': json['authFlow'],
    };
}

export function LoginWithEmailAndPasswordSuccessResponseToJSON(json: any): LoginWithEmailAndPasswordSuccessResponse {
    return LoginWithEmailAndPasswordSuccessResponseToJSONTyped(json, false);
}

export function LoginWithEmailAndPasswordSuccessResponseToJSONTyped(value?: LoginWithEmailAndPasswordSuccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'idToken': value['idToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
        'authFlow': value['authFlow'],
    };
}

